import React, { useCallback, useContext, useEffect, useState } from "react";
import { Route, Routes } from "react-router-dom";
import NotFound from "../utils/NotFound";
import Poster from "../components/welcome/Poster";
import axios from "axios";
import { PermissionInfo, UserInfo } from "../context";
import Delivery from "../components/commissary-employee/delivery";
import MyProcessPO from "../components/commissary-employee/delivery/my-process";
import HomeEmployee from "../components/commissary-employee/home";
import MyProcessPOToPrepare from "../components/commissary-employee/delivery/my-process-prepare";

const CommissaryEmployeeRoute = () => {
  const { userData } = useContext(UserInfo);
  const [permissionList, setPermissionList] = useState({
    data: [],
    ready: false,
  });
  const [poList, setPOList] = useState({
    data: [],
    ready: false,
  });

  const getMyPermissions = useCallback(() => {
    var params = { user_id: userData.data.id };
    axios
      .get("user/commissary-employee/permission-list", {
        params,
      })
      .then((response) => {
        const data = response.data;
        // console.log("DATA", data);
        setPermissionList({ data, ready: true });
      })
      .catch((error) => {
        console.log("ERROR: ", error);
      });
  }, [userData.data.id]);

  const getPOList = useCallback(() => {
    var params = { commissary_user_id: userData.data.userscomemployee.user_id };
    axios
      .get("user/commissary-employee/po-list", { params })
      .then((response) => {
        const data = response.data;
        setPOList({ data, ready: true });
      })
      .catch((error) => {
        console.log("ERROR: ", error);
      });
  }, [userData.data.userscomemployee.user_id]);

  useEffect(() => {
    getMyPermissions();
    getPOList();
  }, [getMyPermissions, getPOList]);

  return (
    <>
      {permissionList.ready && (
        <PermissionInfo.Provider
          value={{
            permissionList,
            poList,
            render: () => getPOList(),
          }}
        >
          <React.Fragment>
            <Routes>
              <Route hidden path="/" element={<HomeEmployee />} />

              {permissionList.ready &&
                permissionList.data.find(
                  ({ permission }) => permission === "acknowledge"
                ) && (
                  <>
                    <Route hidden path="/po" element={<Delivery />} />
                    <Route
                      hidden
                      path="/po-my-process"
                      element={<MyProcessPO />}
                    />
                    <Route
                      hidden
                      path="/po-my-process/:po_number_id/:po_number/:merchant_user_id"
                      element={<MyProcessPOToPrepare />}
                    />
                  </>
                )}

              <Route hidden path="/poster-1" element={<Poster />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </React.Fragment>
        </PermissionInfo.Provider>
      )}
    </>
  );
};

export default CommissaryEmployeeRoute;
